import type { AudienceForm, Group, GroupLike } from '../types';

const hasMarketProperties = (group: Group): boolean => {
  const hasRegion = group.region != null && group.region !== '';
  const hasCountries = Array.isArray(group.countries) && group.countries.length > 0;

  return hasRegion || hasCountries;
};

export const hasInternationalCriteriaInGroups = (groups: GroupLike[] | undefined): boolean => {
  if (!Array.isArray(groups) || groups.length === 0) {
    return false;
  }

  return groups.some(groupLike => {
    if ('groups' in groupLike) {
      return hasInternationalCriteriaInGroups(groupLike.groups);
    }

    return hasMarketProperties(groupLike);
  });
};

export const hasInternationalCriteriaInDefinition = (
  normalizedDefinition: AudienceForm['normalized_definition'] | undefined
): boolean => {
  if (!normalizedDefinition) {
    return false;
  }

  return (
    hasInternationalCriteriaInGroups(normalizedDefinition.includes.groups) ||
    hasInternationalCriteriaInGroups(normalizedDefinition.excludes.groups)
  );
};
